module.exports = __webpack_public_path__ + "7c654bb5e2317d8a1d3258a9cb7cdc9a.svg";